import { createSelector } from 'reselect';

import type { SpartacuxProductDiscoveryDomainState } from '@/productDiscovery/productDiscovery.model';

export type ReviewId = number;
export interface VotesState {
  votes: ReviewId[];
  error?: string;
}

export const VOTE_REVIEW = '@UGC/VOTE_REVIEW';
export const UNDO_VOTE_REVIEW = '@UGC/UNDO_VOTE_REVIEW';

export const initialReviewCardVotingState: VotesState = {
  votes: [],
};

export const votedReviewSelector = (reviewId: ReviewId) =>
  createSelector(
    (state: SpartacuxProductDiscoveryDomainState) =>
      state.productDiscovery?.articleReviews?.votes ||
      initialReviewCardVotingState,
    (state) => !!state.votes.includes(reviewId),
  );
export interface VoteReview {
  type: typeof VOTE_REVIEW;
  reviewId: number;
}
export interface UndoVoteReview {
  type: typeof UNDO_VOTE_REVIEW;
  reviewId: number;
}

export type Action = VoteReview | UndoVoteReview;
export default function reducer(
  state: VotesState = initialReviewCardVotingState,
  action: Action,
): VotesState {
  switch (action.type) {
    case VOTE_REVIEW:
      return {
        votes: [...state.votes, action.reviewId],
      };
    case UNDO_VOTE_REVIEW:
      return {
        votes: state.votes.filter((reviewId) => reviewId !== action.reviewId),
      };
    default:
      return state;
  }
}
